import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('ApiToken').extend('Uuid');

Factory.define('ApiTokenWithDefaults')
  .extend('ApiToken')
  .attr('createdAt', () => new Date().toISOString())
  .attr('name', 'New Token');
